/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {TombOfNefertitiParsedInitData} from "../../server/data/TombOfNefertitiParsedInitData";
import {TombOfNefertitiSpinEvent} from "../../spin/TombOfNefertitiSpinController";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {CoinsFountain} from "../bigwin/CoinsFountain";

export class TombOfNefertitiInitialWinCountUp extends BitmapWinCountUp {
    private _isInitSpinRespin:boolean = false;
    private _isShowing:boolean = false;
    private _endValue:number;
    private _mode:string = "";
    private _nextMode:string = "";

    private maskedCount:BitmapCountUp;
    private counterMask:PIXI.Sprite;

    private _isFloating:boolean;
    private _floatingCurrentRoundWin:BitmapCountUp | null;
    private _floatingTotalRoundWin:BitmapCountUp | null;
    private _winType:string | undefined;

    private _accumulatedWin:number = 0;
    private _isAborted:boolean = false;
    private _name:string;
    private _centerWincontainer:PIXI.Container = new PIXI.Container();

    private xPos:number = 640;
    private topY:number = 410;
    private bottomY:number = 620;

    set winType(value:string | undefined) {
        this._winType = value;
    }

    constructor(name:string, isFloating:boolean = false) {
        super({
            font : {
                name : "nefertitiCountUp",
                size : 100
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._isFloating = isFloating;
        this._name = name;
        this.addGameListeners();
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize && super.onResize(resizeData);

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this.bottomY = 655;
        } else {
            this.bottomY = 620;
        }

        if(this._centerWincontainer.y > this.topY) {
            this._centerWincontainer.y = this.bottomY;
        }
    }

    protected initAnimations():void {
        super.initAnimations();
        this.maskedCount = new BitmapCountUp({
            style : {
                font : {
                    name : "nefertitiCountUpShine",
                    size : 100
                },
                tint : parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            }
        });
        this.maskedCount.shrinkSize = true;
        this.maskedCount.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this.maskedCount.visible = false;

        this.counterMask = new PIXI.Sprite();

        let blankSprite:PIXI.Graphics = new PIXI.Graphics();
        blankSprite.beginFill(0x000000);
        blankSprite.drawRect(0, 0, 10, 10);
        blankSprite.endFill();
        this.counterMask.addChild(blankSprite);
        this.counterMask.anchor.set(0.5);
        //this.counterMask.rotation = -Math.PI/2;

        this.maskedCount.mask = blankSprite;
        this.counterMask.x = -100;
        this.counterMask.setParent(this._countUp.parent);
    }

    public getCountUpAnimation(from:number, to:number, duration:number, multiplier:number, canPlayFountain:boolean = false, coinsFountain:CoinsFountain | null = null):Timeline {
        this._endValue = to;
        this._isAborted = false;

        const oriNumber:number = to / multiplier;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this.setCountUpProperties(multiplier);
            },
            () => this._countUp.getCountUpAnimation(from, oriNumber, {duration : duration, ease : Power3.easeInOut})
        ]);

        if(canPlayFountain) {
            if(this._winType && this._winType.indexOf("Tiny") === -1) {
                timeline.add(TweenLite.to(() => {}, 0.1, {}));
                timeline.add(() => {
                    coinsFountain!.startFountain(0, false);
                    SlotGame.sound.fadeAmbience(1, 200);
                    SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.COIN_SPLASH_FOUNTAIN);
                });
                timeline.add(TweenLite.to(() => {}, duration > 0.4 ? duration : 0.4, {}));
                timeline.add(() => coinsFountain!.stopFountain());
            } else {
                timeline.add(() => SlotGame.sound.fadeAmbience(1, 200));
            }
        } else {
            timeline.add(TweenLite.to(() => {}, duration, {}));
        }

        if(multiplier > 1) {
            const levelTime:number = 0.8 * multiplier > 5 ? MathHelper.roundToDecimals(5 / multiplier, 2) : 0.8;

            timeline.add(TweenLite.to(() => {}, 0.3, {}));

            for(let m:number = 2; m <= multiplier; m++) {
                const showNumber:number = oriNumber * m;
                const scale:number = this.getScale(m, multiplier);
                const scaleDuration:number = multiplier > 3 ? 2 * (levelTime / m) : levelTime / 2;
                timeline.add([
                    () => {
                        // #403
                        if (!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
                            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.MULTIPLIER_BURST);
                        }
                    },
                    this._countUp.getCountUpAnimation(showNumber, showNumber, {duration : 0.01}),
                    TweenLite.to(this._countUpContainer.scale, scaleDuration, {
                            x : scale,
                            y : scale,
                            ease : Elastic.easeOut.config(2, 1)
                        }
                    ),
                ]);
            }
        }

        return timeline;
    }

    public abort(endValue:number, isAborted:boolean, multiplier:number, isBigWin:boolean):Timeline | null {
        this._isAborted = isAborted;
        if(isBigWin || !endValue) {
            return null;
        }

        this._endValue = endValue;

        return super.abort(endValue, isAborted, multiplier);
    }

    private killAllTweens():void {
        TweenLite.killTweensOf(this._countUpContainer);
        TweenLite.killTweensOf(this.counterMask);
        this.counterMask.x = this.maskedCount.x + this.maskedCount.width + 20;
    }

    public getEndingAnimation(endValue:number, isNormal:boolean):Timeline {
        const timeline:TimelineLite = new TimelineLite({
            onStart : () => {
                if(this._countUp.visible) {
                    this.maskedCount.visible = true;
                } else {
                    this.maskedCount.visible = false;
                    return;
                }

                this.maskedCount.x = this._countUp.x;
                this.maskedCount.y = this._countUp.y;
                this.maskedCount.setParent(this._countUp.parent);
                this.maskedCount.getCountUpAnimation(endValue, endValue, {duration : 0});
                this.maskedCount.scale.set(this._countUp.scale.x, this._countUp.scale.y);
                this.counterMask.x = this.maskedCount.x - this.maskedCount.width / 2 - (this.counterMask.children[0] as PIXI.Graphics).width / 2;
                this.counterMask.y = this.maskedCount.y;
                (this.counterMask.children[0] as PIXI.Graphics).width = 20;
                (this.counterMask.children[0] as PIXI.Graphics).height = this.maskedCount.height;
                this.counterMask.y = this.maskedCount.y - this.maskedCount.height / 2;
                if(!this._isAborted) {
                    TweenLite.to(this.counterMask, 0.4, {x : this.counterMask.x + this.maskedCount.width + 20})
                } else {
                    this.maskedCount.visible = false;
                }
            }
        });
        timeline.add(() => {
            this._isShowing = false;
        });

        if(endValue) {
            timeline.add(() => {
                this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
            });
        }

        if(!this._isAborted) {
            if(this._isFloating && (this._mode.indexOf("FREESPIN") !== -1)) {
                timeline.add(() => {
                    this.updateRoundWinAmount();
                    TweenLite.to(this._countUp, 0.4, {alpha : 0});
                }, 0.8);
            } else {
                timeline.add(() => {
                    TweenLite.to(this._countUp, 0.4, {alpha : 0})
                }, timeline.totalDuration() + 0.8); // stay a while after count up.
            }
        } else {
            TweenLite.to(this._countUp, 0.5, {alpha : 0});
            TweenLite.killTweensOf(this._centerWincontainer);
            this.killAllTweens();

            if(this._isFloating) {
                if(this._nextMode.indexOf("RESPIN") !== -1) {
                    this.initializeBottomWinAmount();
                } else {
                    this.updateRoundWinField(0, true);
                    this._centerWincontainer!.y = this.topY;
                }
            }
        }
        return timeline;
    }

    private initializeBottomWinAmount():void {
        this.updateRoundWinField();
        this._centerWincontainer!.y = this.bottomY;
        this._centerWincontainer!.scale.set(1);
        this._centerWincontainer!.visible = true;
        this._centerWincontainer!.alpha = 1;
    }

    public resetColleactiveWin():void {
        if(this._floatingTotalRoundWin) {
            TweenLite.to(this._centerWincontainer, 0.25, {
                alpha : 0, onComplete : () => {

                    this._centerWincontainer!.y = this.bottomY;
                    this._centerWincontainer!.scale.set(1);
                    this._centerWincontainer!.visible = false;
                    this._centerWincontainer!.alpha = 1;
                }
            });
        }
    }

    public showTotalWin(finalAmount:number, showFinalAmount:boolean = false):void {
        // #415
        this._centerWincontainer.visible = !TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE;

        if(this._centerWincontainer.y === 410) {
            TweenLite.to(this._centerWincontainer, 0.4, {y : this.topY});
            return;
        }

        if(!this._floatingTotalRoundWin) {
            this.getTotalRoundWinField();
        }
        EventHandler.dispatchEvent(new GameEvent("SHOW_TOTAL_WIN"));

        EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiSpinEvent.ADD_DELAY_IN_START_SPIN, 0.8));
        TweenLite.to(this._centerWincontainer, 0.4, {y : this.topY});
        TweenLite.to(this._centerWincontainer!.scale, 0.4, {
            x : 2, y : 2, onComplete :
                () => {
                    // #403
                    if(!TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
                        SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.WIN_TOTAL);
                    }
                    //#407
                    //if(!this._isAborted || showFinalAmount) {
                    // #398, #415
                    if (!TombOfNefertitiGameConfig.instance.FS_OUTRO_VISIBLE && !TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
                        this.updateRoundWinField(finalAmount, true);
                    }

                    EventHandler.dispatchEvent(new GameEvent(TombOfNefertitiSpinEvent.ADD_DELAY_IN_START_SPIN, 0));
                    EventHandler.dispatchEvent(new GameEvent("FinishWinPres"));
                },
            onStart : () => {
                if(Number(this._floatingTotalRoundWin!.text) === 0) {
                    this._centerWincontainer!.visible = false;
                }
                // #403
                if(this._centerWincontainer!.visible && this._centerWincontainer!.alpha && !TombOfNefertitiGameConfig.instance.WIN_BELOW_STAKE) {
                    SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.WIN_AMOUNT_UP);
                }
            }
        });
    }

    public updateRoundWinAmount():void {
        TweenLite.to(this._countUp, 0.4, {alpha : 0});

        let winAmount:number = this._accumulatedWin;
        TweenLite.to(this._countUpContainer, 0.25, {y : this.bottomY - this.topY});
        TweenLite.to(this._countUpContainer.scale, 0.25, {
            x : 0.4, y : 0.4, onComplete :
                () => {
                    this.updateRoundWinField(winAmount);
                }
        });
    }

    private updateRoundWinField(finalWinAmount:number = 0, useScaledValue:boolean = false):void {
        this.getTotalRoundWinField();

        let winToShow:number = this._accumulatedWin;
        if(finalWinAmount) {
            winToShow = finalWinAmount;
        }
        this._floatingTotalRoundWin!.getCountUpAnimation(winToShow, winToShow, {duration : 0});
        this._centerWincontainer!.visible = true;

        if(useScaledValue) {
            this._centerWincontainer!.y = this.topY;
            this._centerWincontainer!.scale.set(2);
        } else {
            this._centerWincontainer!.y = this.bottomY;
        }
    }

    private getTotalRoundWinField():void {
        if(!this._floatingTotalRoundWin) {
            this._floatingTotalRoundWin = new BitmapCountUp({
                style : {
                    font : {
                        name : "nefertitiCountUp",
                        size : 48
                    },
                    tint : parseInt(("#FFFFFF").replace(/^#/, ''), 16)
                }
            });

            this._centerWincontainer.addChild(this._floatingTotalRoundWin);
            let animationLayer:PIXI.Container = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
            this._centerWincontainer.setParent(animationLayer);
            this._centerWincontainer.x = this.xPos;
            this._centerWincontainer.scale.set(1);
            this._centerWincontainer.visible = true;
            this._centerWincontainer.y = this.bottomY;
        }
    }

    protected getAbortAnimation(endValue:number, multiplier:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();

        timeline.add([
            () => this.setCountUpProperties(multiplier),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        if(multiplier > 1) {
            const scale:number = this.getScale(multiplier);
            timeline.add(TweenLite.to(this._countUpContainer.scale, 0.1, {
                x : scale,
                y : scale,
                ease : Elastic.easeOut.config(2, 1)
            }), 0)
        }

        return timeline;
    }

    protected addGameListeners():void {
        if(this._isFloating) {
            EventHandler.addEventListener(this, "FORCE_HIDE_TOTAL_WIN", (event:GameEvent) => {
                if(this._isInitSpinRespin) {
                    this._isInitSpinRespin = false;
                    return;
                }
                this.resetColleactiveWin();
                this.killAllTweens();
            });
            EventHandler.addEventListener(this, "UPDATE_INIT_COUNTUP", (event:GameEvent) => {
                if(this._name === "INITIAL_WIN") {
                    if(this._nextMode.indexOf("RESPIN") !== -1) {
                        this.updateRoundWinField((event.params[0]));
                    } else {
                        this.getTotalRoundWinField();
                        this.showTotalWin(event.params[0], true);
                    }
                }
            });
            EventHandler.addEventListener(this, "hideTotalWin", (event:GameEvent) => {
                this.resetColleactiveWin();
            });

            EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => {
                if((event.params[0].mode.indexOf(GameMode.FREESPIN) === -1) && (event.params[0].nextMode.indexOf(GameMode.FREESPIN) !== -1)) {
                    return;
                }
                let data:TombOfNefertitiParsedInitData = (event.params[0]);
                this._accumulatedWin = data.totalRespinWin;
                if(this._accumulatedWin) {
                    this.initializeBottomWinAmount();
                    this._isInitSpinRespin = true;
                }
            });
        }

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => {
            this._mode = event.params[0].mode;
            this._nextMode = event.params[0].nextMode;
            this._accumulatedWin = event.params[0].totalRespinWin;
        });
    }

    private getScale(multiplier:number, finalMultiplier:number = 1):number {
        if(this._mode.indexOf(GameMode.FREESPIN) !== -1) {
            const maxScale:number = 3,
                minScale:number = 1;

            let retVal:number = 1 + ((multiplier - 1) * 0.1);

            if((1 + ((finalMultiplier - 1) * 0.1)) > maxScale) {
                retVal = 1 + (((maxScale - minScale) / finalMultiplier) * (multiplier - 1));
            }

            return retVal;
        } else {
            if(multiplier === 1) {
                return 1.5;
            } else if(multiplier === 2) {
                return 1.75;
            } else {
                return 2;
            }
        }
    }

    private setCountUpProperties(multiplier:number):void {
        this._countUpContainer.position.set(0, 0);
        this._countUpContainer.scale.set(1, 1);
        this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.45;
        this.maskedCount.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.45;
        this._countUp.alpha = 1;
        this._countUp.visible = true;
        if(multiplier === 1 && this._mode.indexOf(GameMode.FREESPIN) === -1) {
            this._countUpContainer.scale.set(1.5);
        } else {
            this._countUpContainer.scale.set(1);
        }
        this._isShowing = true;
    }
}